import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * @file 下拉选择类型，type: 'select-tree' | 'select' | 'date-picker'
 * @author alfielv
 */
import React, { useState } from 'react';
import classNames from 'classnames';
import { Icon } from '@tencent/spaui';
import FilterComponents from '../components';
import FilterSelect from '../components/Select';

var FilterSelection = function FilterSelection(props) {
  var type = props.type,
      name = props.name,
      title = props.title,
      config = props.config,
      nameConfig = props.nameConfig,
      value = props.value,
      onChange = props.onChange,
      onNameChange = props.onNameChange,
      onClear = props.onClear,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? true : _props$clearable;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var FilterComponent = FilterComponents[type];
  var nameElement = nameConfig ? /*#__PURE__*/React.createElement(FilterSelect, {
    config: nameConfig,
    setActive: setActive,
    value: name,
    onChange: onNameChange
  }) : title;
  return /*#__PURE__*/React.createElement("div", {
    id: "filter-item__".concat(name),
    className: classNames('filter-item', {
      'filter-item-active': active
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-item-key"
  }, nameElement), /*#__PURE__*/React.createElement("span", {
    className: "filter-item-val"
  }, /*#__PURE__*/React.createElement(FilterComponent, {
    config: config,
    setActive: setActive,
    value: value,
    name: name,
    onChange: onChange
  })), clearable && /*#__PURE__*/React.createElement("span", {
    className: "filter-item-clear-btn",
    onClick: onClear
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close",
    className: "meta-clear"
  })));
};

export default FilterSelection;